import { useQuery } from 'react-query';

import { Organization } from '@components/pages/Organization/types';
import { ORGANIZATION_DETAILS_KEY, getOrganizationDetails } from '@utils/backend-api/organizations';

const useOrganizationDetails = () => {
  return useQuery<Organization>([ORGANIZATION_DETAILS_KEY], getOrganizationDetails, {
    staleTime: 5 * 60 * 1000,
    cacheTime: 10 * 60 * 1000,
    refetchOnWindowFocus: true,
    retry: 2,
  });
};

export default useOrganizationDetails;
